
const DEFAULT_URL_OID = 'https://winline.by/api/partner-program/admon/visit';
const DEFAULT_URL_AAID = 'https://winline.by/api/partner-program/visit';

export default function handleAdmonParams(currentUrlOid, currentUrlAAid) {
    const urlOid = currentUrlOid || DEFAULT_URL_OID;
    const urlAAid = currentUrlAAid || DEFAULT_URL_AAID;
    
    if (!window.location.search) {
        return null;
    }

    const params = new URLSearchParams(window.location.search);

    const setCookies = (keys) => {
        keys.forEach(key => {
            const value = params.get(key);
            if (value) {
                document.cookie = `${key}=${encodeURIComponent(value)}; path=/; max-age=604800`;
            }
        });
    };

    const sendPostRequest = (url, data) => {
        if (!url || !data) {
            return null;
        }

        $.ajax({
            type: 'POST',
            url,
            data: JSON.stringify(data),
            contentType: 'application/json',
            success() {
                console.log('POST successful');
            },
            error(xhr, status, error) {
                console.error('POST failed:', error);
                console.error('Ответ сервера:', xhr.responseText);
            }
        });
    };

    const postAffiliateDataOid = (url) => {
        const affiliateId = params.get('affiliateId');
        const clickId = params.get('clickId');
        const offerId = params.get('offerId');
        const keys = ['oid', 'affiliateId', 'clickId', 'offerId'];

        if (!affiliateId) {
            return null;
        }

        const data = {
            affiliateId,
            ...(clickId && { clickId }),
            ...(offerId && { offerId }),
        };

        setCookies(keys);
        sendPostRequest(url, data);
    };

    const postAffiliateDataAAid = (url) => {
        const partnerId = params.get('partnerId');
        const bannerId = params.get('bannerId');
        const channel = params.get('channel');
        const data1 = params.get('data1');
        const data2 = params.get('data2');
        const keys = ['a_aid', 'partnerId', 'bannerId', 'channel', 'data1', 'data2'];

        if (!partnerId || !bannerId) {
            return null;
        }

        const data = {
            partnerId,
            bannerId,
            ...(channel && { channel }),
            ...(data1 && { data1 }),
            ...(data2 && { data2 }),
        };

        setCookies(keys);
        sendPostRequest(url, data);
    };

    if (params.has('oid')) {
        setIapSDK();
        postAffiliateDataOid(urlOid);
    }

    if (params.has('a_aid')) {
        postAffiliateDataAAid(urlAAid);
    }
}

function setIapSDK() {
    (function() { 
        iapSDK = window.iapSDK || (window.iapSDK = []);
        var s = document.createElement('script');
        s.type = 'text/javascript'; 
        s.async = true; 
        s.src = '//partners2.winline.ru/api/tracker/sdk.js';
        var x = document.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
    })();

    iapSDK.push([ 'init', { apiUrl: '//partners2.winline.ru/api'}]); 
};



// WEBPACK FOOTER //
// ./_layout/js/handleAdmonParams.js